class MediaUtils {
  static backgrounUrl = 'https://asters-general.s3.eu-central-1.amazonaws.com/background-blurred-expired.png'
  static workspacePlaceholder = 'https://asters-general.s3.eu-central-1.amazonaws.com/generic_workspace-placeholder.gif'
}

export default MediaUtils
